import React from 'react';
import {Stack} from '@mui/material';
import {APP_HEADER_HEIGHT} from '../../../../App';
import {NavHeader} from './NavHeader';

export function WorkbookPageHeader(props) {
  return (
    <Stack
      sx={{
        position: 'sticky',
        top: APP_HEADER_HEIGHT,
        zIndex: 1,
      }}
    >
      <NavHeader {...props} />
    </Stack>
  );
}
